<template>
  <el-dialog
    title="新增互动"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="500px"
  >
    <div class="dialog_box">
      <el-form ref="ruleForm" :rules="rules" :model="form" label-width="100px">
        <el-form-item label="姓名：">
          {{ userInfo.userName }}
        </el-form-item>
        <el-form-item label="职务：">
          <el-input
            size="small"
            clearable
            placeholder="请输入职务名称"
            style="width:100%"
            v-model.trim="form.position"
          ></el-input>
        </el-form-item>
        <el-form-item prop="eventContent" label="事件：">
          <el-select
            size="small"
            v-model="form.eventContent"
            placeholder="请选择事件"
            style="width: 100%;"
          >
            <el-option
              v-for="(item, index) in eventList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="content" label="内容：">
          <el-input
            size="small"
            type="textarea"
            clearable
            placeholder="请输入内容"
            style="width:100%"
            v-model.trim="form.content"
          ></el-input>
        </el-form-item>
        <el-form-item prop="policeId" label="受理民警：">
          <el-select
            size="small"
            v-model="form.policeId"
            placeholder="请选择受理民警"
            style="width: 100%;"
          >
            <el-option
              v-for="(item, index) in policeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="timeLimit" label="受理时限：">
          <el-input-number
            size="small"
            v-model="form.timeLimit"
            @change="handleChange"
            :min="1"
            :max="1000"
            label="描述文字"
          ></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="handleClose">取 消</el-button>
          <el-button size="small" type="primary" @click="saveClick('ruleForm')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "interactAdd",
  components: {},
  props: {
    resize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    //这里存放数据
    return {
      userInfo: this.$store.getters.getUserInfo,
      rules: {
        eventContent: [{ required: true, message: " ", trigger: "blur" }],
        content: [{ required: true, message: " ", trigger: "blur" }],
        timeLimit: [{ required: true, message: " ", trigger: "blur" }],
        policeId: [{ required: true, message: " ", trigger: "blur" }]
      },
      showDialog: false,
      eventList: [],
      policeList: [],
      form: {
        userId: this.$store.getters.getUserInfo.userId,
        position: "",
        eventContent: "",
        content: "",
        policeId: "",
        timeLimit: "",
        type: 1
      }
    };
  },
  //监控data中的数据变化
  watch: {
    resize: function(val) {
      if (val) {
        this.showDialog = true;
        this.getProtectEvent();
        this.getProtectPolice();
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    handleClose() {
      this.clearData();
      this.showDialog = false;
    },
    handleChange(value) {
      // console.log(value);
    },
    clearData() {
      this.form = {
        userId: this.$store.getters.getUserInfo.userId,
        position: "",
        eventContent: "",
        content: "",
        policeId: "",
        timeLimit: "",
        type: 1
      };
    },
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addInteract();
        } else {
          return false;
        }
      });
    },
    async addInteract() {
      let req = this.form;
      let res = await this.$Http.addInteract(req);
      if (res.code == 200) {
        this.handleClose();
        this.$emit("getList");
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getProtectEvent() {
      let req = {
        pageNum: 1,
        pageSize: 1000
      };
      let res = await this.$Http.getProtectEvent(req);
      if (res.code == 200) {
        this.eventList = res.data.list.map((element) => {
          return {
            label: element.eventContent,
            value: element.eventContent
          };
        });
      } else if (res.code == 101) {
        this.eventList = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async getProtectPolice() {
      let req = {
        pageNum: 1,
        pageSize: 1000
      };
      let res = await this.$Http.getProtectPolice(req);
      if (res.code == 200) {
        this.policeList = res.data.list.map((element) => {
          return {
            label: element.userName,
            value: element.userId
          };
        });
      } else if (res.code == 101) {
        this.policeList = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.dialog_box {
  padding: 10px;
}
</style>
